export const cartEventTopic = {
    cartQuantityUpdated: "estore.callback.shopcart.updatecartquantity",
    cartItemsRemoved: "estore.callback.shopcart.removefromcart",
    cartEmptied: "estore.callback.shopcart.emptycart",
    addedToCart: "estore.callback.shopcart.addtocart",
    detailedCartChanged: "detailedcart.changed",
    siteCartChanged: "sitecart.changed",
};